// Definición de las 6 misiones de Planeta Resta.
// Todos los generadores garantizan a >= b: nunca producen resultados negativos.

import { rnd } from '../math/operations';

export const RESTA_MISSIONS = [
  { index: 0, num: 1, name: 'Planeta 1', skill: 'Resta: 1 dígito − 1 dígito', desc: 'Resta dos números de un dígito sin resultados negativos.', type: 'single', time: 90 },
  { index: 1, num: 2, name: 'Planeta 2', skill: 'Resta: 2 dígitos, sin reagrupación', desc: 'Resta números de 2 dígitos sin reagrupación.', type: 'two_no_regroup', time: 100 },
  { index: 2, num: 3, name: 'Planeta 3', skill: 'Resta: 2 dígitos, con reagrupación', desc: 'Resta números de 2 dígitos con reagrupación (pedir prestado).', type: 'two_regroup', time: 110 },
  { index: 3, num: 4, name: 'Planeta 4', skill: 'Resta: 3 dígitos, sin reagrupación', desc: 'Resta números de 3 dígitos sin reagrupación.', type: 'three_no_regroup', time: 120 },
  { index: 4, num: 5, name: 'Planeta 5', skill: 'Resta: 3 dígitos, con reagrupación', desc: 'Resta números de 3 dígitos con reagrupación (pedir prestado).', type: 'three_regroup', time: 130 },
  { index: 5, num: 6, name: 'Planeta 6', skill: 'Resta: destrezas mixtas', desc: 'Combina todas las destrezas de resta anteriores.', type: 'mixed', time: 140 },
];

function hasBorrow(a, b) {
  let x = a;
  let y = b;
  while (x > 0 || y > 0) {
    if ((x % 10) < (y % 10)) return true;
    x = Math.floor(x / 10);
    y = Math.floor(y / 10);
  }
  return false;
}

function singleDigit() {
  const a = rnd(0, 9);
  return { a, b: rnd(0, a) };
}

function twoDigitNoRegroup() {
  const ta = rnd(1, 9);
  const tb = rnd(1, ta);
  const ua = rnd(0, 9);
  const ub = rnd(0, ua);
  return { a: ta * 10 + ua, b: tb * 10 + ub };
}

function twoDigitRegroup() {
  const ta = rnd(2, 9);
  const tb = rnd(1, ta - 1);
  const ua = rnd(0, 8);
  const ub = rnd(ua + 1, 9);
  return { a: ta * 10 + ua, b: tb * 10 + ub };
}

function threeDigitNoRegroup() {
  const ha = rnd(1, 9);
  const hb = rnd(1, ha);
  const ta = rnd(0, 9);
  const tb = rnd(0, ta);
  const ua = rnd(0, 9);
  const ub = rnd(0, ua);
  return { a: ha * 100 + ta * 10 + ua, b: hb * 100 + tb * 10 + ub };
}

function threeDigitRegroup() {
  let a;
  let b;
  do {
    a = rnd(100, 999);
    b = rnd(100, a);
  } while (!hasBorrow(a, b));
  return { a, b };
}

const GENERATORS = {
  single: singleDigit,
  two_no_regroup: twoDigitNoRegroup,
  two_regroup: twoDigitRegroup,
  three_no_regroup: threeDigitNoRegroup,
  three_regroup: threeDigitRegroup,
};

export function genSubtraction(type) {
  if (type === 'mixed') {
    const keys = Object.keys(GENERATORS);
    return GENERATORS[keys[rnd(0, keys.length - 1)]]();
  }
  return (GENERATORS[type] || GENERATORS.single)();
}
